import initRetinaCover from './retina';

export default function ajaxFilter() {
	let form = jQuery('#ajax-filter');
	let replaceContent = jQuery('#ajax-replace');

	jQuery('.load-more').on('click', function(e){
		e.preventDefault();

		let pageInput = form.find('input[name="paged"]');
		if (typeof(pageInput.val()) !== 'undefined' ) {
			pageInput.val(parseInt(pageInput.val())+1)
		} else {
			let newTag = jQuery('<input type="hidden" name="paged" value="2">');
			form.append(newTag);
		}

		form.submit();
	});

	form.on('submit', function () {
		let query = jQuery(this).serializeArray();

		jQuery.get(document.location, query, function (data) {
			let newElement = jQuery(data).find('#ajax-replace');
			let newContent = newElement.children();

			replaceContent.append(newContent.css('opacity', 0).animate({'opacity': 1}, 500));
			let maxPage = newElement.attr('data-max-page');
			replaceContent.attr('data-max-page', maxPage);

			let pageInput = form.find('input[name="paged"]').val();
			if ((typeof(pageInput) === 'undefined') || (pageInput === 'undefined') ) {
				pageInput = 1;
			} else {
				pageInput = parseInt(pageInput);
			}

			if (pageInput >= maxPage) {
				jQuery('.load-more-wrapper').fadeOut();
			} else {
				jQuery('.load-more-wrapper').fadeIn();
			}
		});

		return false;
	});

}